export default __webpack_public_path__ + "static/media/user_icon_v2.b07f085d.png";